"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionInfo = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const InfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/InfoIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const InfoBox_1 = __importDefault(require("../../OpPerformQuestionCard/InfoBox"));
const OpPerformQuestionHighlight_1 = __importDefault(require("../../OpPerformQuestionHighlight"));
const OpPerformQuestionIndent_1 = __importDefault(require("../../OpPerformQuestionIndent"));
const makeMyClasses = () => ({
    spacer: {
        width: 8,
    },
});
function OpPerformQuestionInfo(props) {
    const { highlightSelected } = props;
    const { question, selected, rule } = (0, usePerformQuestion_1.default)();
    const { html, files } = rule.richInfo;
    const hasInfo = !!(html === null || html === void 0 ? void 0 : html.length) || !!(files === null || files === void 0 ? void 0 : files.length);
    const stateColor = selected ? lib_palette_1.default.secondary : undefined;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const [title] = (0, useAltForSelfLang_1.default)(question === null || question === void 0 ? void 0 : question.title, question === null || question === void 0 ? void 0 : question.titleAlt);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Horizontal_1.default, { shrink: true },
        react_1.default.createElement(OpPerformQuestionIndent_1.default, null),
        react_1.default.createElement(OpPerformQuestionHighlight_1.default, { highlightSelected: highlightSelected, grow: true, paper: true, color: stateColor, padding: true },
            react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', centered: true, paddingY: true },
                react_1.default.createElement(InfoIcon_1.default, { color: lib_palette_1.default.GoodOldBlue.main }),
                react_1.default.createElement(Pane_1.default, { classes: { root: myCss.spacer } }),
                react_1.default.createElement(Text_1.default, { variant: "h2" }, title)),
            hasInfo ? (react_1.default.createElement(Pane_1.default, { paddingY: true },
                react_1.default.createElement(InfoBox_1.default, null))) : null))), [highlightSelected, stateColor, myCss, title, hasInfo]);
}
exports.OpPerformQuestionInfo = OpPerformQuestionInfo;
exports.default = OpPerformQuestionInfo;
